<section class="roadmap" id="roadmap">
  <!-- <div class="roadmap__blob roadmap__blob--cyan"></div>
  <div class="roadmap__blob roadmap__blob--green"></div> -->

  <div class="roadmap__container">

    <!-- ── Section Header ─────────────────────────────────────────────── -->
    <div class="roadmap__header">
      <div class="roadmap__eyebrow">
        <span class="roadmap__eyebrow-line"></span>
        <span class="roadmap__eyebrow-text">{{ 'roadmap.eyebrow' | translate }}</span>
        <span class="roadmap__eyebrow-line"></span>

      </div>
      <h2 class="roadmap__title">
        <span>{{ 'roadmap.title_1' | translate }}</span>
        {{ 'roadmap.title_2' | translate }}
      </h2>
      <p class="roadmap__subtitle">{{ 'roadmap.subtitle' | translate }}</p>
    </div>

    <!-- ── Kinetic Timeline ───────────────────────────────────────────── -->
    <div class="roadmap__timeline">
      <!-- <div class="roadmap__line-fill" [style.height.%]="scrollProgress"></div> -->
      @for (phase of phases; track phase.id) {
      <div class="roadmap__entry" [class.roadmap__entry--left]="phase.side === 'left'"
        [class.roadmap__entry--right]="phase.side === 'right'">
        <div class="roadmap__card-wrap">
          <div class="roadmap__card" [class.roadmap__card--completed]="phase.status === 'completed'"
            [class.roadmap__card--current]="phase.status === 'current'"
            [class.roadmap__card--future]="phase.status === 'future'">
            <div class="roadmap__card-head">
              <h3 class="roadmap__card-title">{{ phase.titleKey | translate }}</h3>
              @if (phase.badgeKey) {
              <span class="roadmap__badge">{{ phase.badgeKey | translate }}</span>
              }
            </div>

            <ul class="roadmap__list">
              @for (item of phase.items; track item.textKey) {
              <li class="roadmap__item" [class.roadmap__item--done]="item.status === 'done'"
                [class.roadmap__item--check]="item.status === 'check'"
                [class.roadmap__item--pending]="item.status === 'pending'"
                [class.roadmap__item--future]="item.status === 'future'">
                <span class="roadmap__item-icon"><img src="{{ item.img }}" alt="images"></span>
                <span class="roadmap__item-text" [class.roadmap__item-text--white]="item.status === 'check'">{{
                  item.textKey | translate }}</span>
              </li>
              }
            </ul>

            <span class="roadmap__number">{{ phase.id }}</span>
          </div>
        </div>

        <!-- <div class="roadmap__dot" [class.roadmap__dot--cyan]="phase.dotColor === 'cyan'"
          [class.roadmap__dot--green]="phase.dotColor === 'green'" [class.roadmap__dot--dim]="phase.dotColor === 'dim'"
          [class.roadmap__dot--red]="phase.dotColor === 'red'"></div> -->
      </div>
      }
    </div>

    <!-- ── Bento Stats Grid ───────────────────────────────────────────── -->
    <div class="roadmap__bento">
      @for (stat of stats; track stat.titleKey) {
      <div class="roadmap__stat" [class.roadmap__stat--wide]="stat.wide" [style.backgroundColor]="stat.bg">

        <div class="roadmap__stat-label" [class.roadmap__stat-label--green]="stat.labelAccent === 'green'"
          [class.roadmap__stat-label--cyan]="stat.labelAccent === 'cyan'">{{ stat.labelKey | translate }}</div>

        <!-- <div class="roadmap__stat-title" [class.roadmap__stat-title--lg]="stat.titleLarge">{{ stat.titleKey | translate
          }}</div> -->
        <p class="my-2" *ngIf="stat.creadshield === true">{{ stat.audit_text | translate }}</p>
        <a href="/assets/documents/credshield_audit.pdf" target="_blank" *ngIf="stat.creadshield === true"
          class="me-auto ">
          <img src="/assets/images/png/credshield.png" alt="CredShield logo"
            class="roadmap__stat-credshield img-fluid mwx-100">
        </a>

        <div class="roadmap__stat-counter" *ngIf="stat.animatedValue !== undefined">
          <div class="roadmap__stat-value" [class.roadmap__stat-value--lg]="stat.wide">
            @if (stat.currencyFormat) {
            <span class="roadmap__stat-currency">$</span>
            {{ stat.animatedValue | number:'1.2-2' }}
            } @else {
            {{ stat.animatedValue }}
            @if (stat.valueSuffixKey) {
            <span class="roadmap__stat-suffix">
              {{ stat.valueSuffixKey | translate }}
            </span>
            }
            }
          </div>
        </div>

        <div class="roadmap__stat-value" [class.roadmap__stat-value--lg]="stat.wide"
          *ngIf="stat.animatedValue === undefined">
          {{ stat.valueKey | translate
          }}
          @if (stat.valueSuffixKey) {<span class="roadmap__stat-suffix">{{ stat.valueSuffixKey | translate }}</span>}
        </div>

        @if (stat.extra === 'bars') {
        <div class="roadmap__stat-bars">
          <span class="roadmap__stat-bar roadmap__stat-bar--on"></span>
          <span class="roadmap__stat-bar roadmap__stat-bar--on"></span>
          <span class="roadmap__stat-bar roadmap__stat-bar--on"></span>
          <span class="roadmap__stat-bar"></span>
          <span class="roadmap__stat-bar"></span>
        </div>
        }

        @if (stat.extra === 'badge') {
        <div class="roadmap__stat-change">{{ stat.badgeKey | translate }}</div>
        }

      </div>
      }
    </div>

  </div>
</section>